import http from '../../core/services/http';
import transformLoadServiceOptions from './transformLoadServiceOptions';

const loadServiceOptions = address =>
  http
    .post('marketconfig/address', { zipCode: address.zipCode, address: address.address })
    .then(response => transformLoadServiceOptions(response.data));

export default loadServiceOptions;
